import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const DefaultListHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="doc-header">
      <span className="doc-header__col">{t('Name')}</span>
      <span className="doc-header__col doc-header__col--right">
        {t('DocumentDate')}
      </span>
      <span className="doc-header__col doc-header__col--right">
        {t('Size')}
      </span>
      <span />
    </div>
  );
};

export default DefaultListHeader;
